import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../contexts/AppContext";
import GeneralButton from "../../../components/GeneralButton/GeneralButton";
import "../../../styles/globals.css";
import "./UnsubscribeSettingPage.css";
import { Checkbox } from "antd";
import { showToast } from "../../../utils/commonUtils";
import { sendUnsubscribe } from "../../../services/service";

/**
 * 退会手続き画面用のコンポーネント
 * @param {} なし
 * @return {} なし
 */
function UnsubscribeSettingPage() {
  const navigate = useNavigate();
  const {
    setGlobalLoginUserInfo,
    globalEmailAddress,
    globalAccessToken,
    globalLoginUserInfo,
  } = useContext(AppContext);
  const [agreementChecked, setAgreementChecked] = useState(false);

  /**
   * 同意チェックボックス変更時の処理
   * @param {object} e - イベントオブジェクト
   */
  const handleAgreementChange = (e) => {
    setAgreementChecked(e.target.checked);
  };

  /**
   * 送信ボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleUnsubscribeRegistClick = async () => {
    try {
      const data = await sendUnsubscribe(
        globalAccessToken,
        globalEmailAddress,
        globalLoginUserInfo?.userInfo?.kanjiLast,
        globalLoginUserInfo?.userInfo?.kanjiFirst
      );
      if (data.result.status === "OK") {
        // ログアウト状態に
        setGlobalLoginUserInfo(null);

        // 退会手続き完了画面に遷移
        navigate("/mypage/unsubscribe/done");
      } else {
        showToast(data?.result?.error_message, "error");
      }
    } catch (error) {
      showToast("退会手続きに失敗しました", "error");
      console.error("Error sendUnsubscribe:", error);
    }
  };
  /**
   * 戻るボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleBackClick = () => {
    navigate("/mypage/menu");
  };

  return (
    <div className="unsubscribe-setting">
      <div className="main-area">
        <div className="title">退会手続き</div>
        <div className="detail">
          退会する場合は以下をご確認の上、チェックをして退会ボタンを押してください。
        </div>

        <div className="unsubscribe-warning">
          <ul>
            <li>
              退会すると、お客様のアカウント情報はすべて削除され、復旧することはできません。
            </li>
          </ul>
        </div>

        <div className="form">
          <div className="agreement">
            <Checkbox onChange={handleAgreementChange}>
              確認事項に同意の上、退会する
            </Checkbox>
          </div>
        </div>

        <div className="general-buttons">
          <GeneralButton
            buttonLabel={"送信"}
            type={!agreementChecked ? "disabled" : "primary-blue"}
            onClick={handleUnsubscribeRegistClick}
          />
          <GeneralButton
            buttonLabel={"マイページに戻る"}
            type={"secondary-white"}
            onClick={handleBackClick}
          />
        </div>
      </div>
    </div>
  );
}
export default UnsubscribeSettingPage;
